"use client"
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, Autoplay, } from 'swiper/modules';
import Link from 'next/link';
import Image from 'next/image';
// import { getAllProducts } from '@/API/response';
import { useDispatch, useSelector } from 'react-redux';
import { getBrandStart, getBrandSuccess } from '@/GlobalRedux/Slices/allBrands';
const Slider = ({brandData}) => {
    const [selectedBrand, setSelectedBrand] = useState(null);
    const dispatch = useDispatch();
    const getAllBrand = async () => {
        dispatch(getBrandStart()) 
        dispatch(getBrandSuccess(brandData))
        // const res = await getAllProducts('brand')
    
       }
       const { allBrands, isLoader } = useSelector((state) => state.allBrand)
    useEffect(() => {
        getAllBrand()
      }, []);
   
    return (
        <Swiper
            modules={[Navigation, Pagination, A11y, Autoplay]}
            spaceBetween={20}
            //  slidesPerView={5}
            loop={true}
            autoplay={{
                delay: 700, // 3 seconds
                disableOnInteraction: false,
                reverseDirection: true
            }}

            speed={1000}
            breakpoints={{
                320: { slidesPerView: 2.5 },
                500: { slidesPerView: 3.5 },
                650: { slidesPerView: 4 },
                1024: { slidesPerView: 5 },
            }}
            className='flex justify-center w-full items-center gap-2 py-4 swiper   h-1/2'>
            {
                allBrands?.map((brand, index) => (
                    <SwiperSlide key={index} onClick={()=>setSelectedBrand(brand?.name)}>
                        <Link href={`/products?brand=${encodeURIComponent(brand?.name)}`}>
                            <div className="flex justify-center flex-col items-center h-full">
                                {/* Circle Container */}
                                <div className="relative w-32 h-32 md:w-44 md:h-44 hover:cursor-pointer
               rounded-full bg-gray-200 overflow-hidden group border-2 border-gray-100">
                                    {/* Split Image: Left Part */}
                                    {/* <div className="absolute left-0 w-1/2 h-full overflow-hidden bg-blue-gray-800 opacity-70 transition-all duration-700 group-hover:translate-x-[-100%]">

                                    </div>

                                    <div className="absolute right-0 w-1/2 h-full overflow-hidden bg-blue-gray-800 opacity-70  transition-all duration-700 group-hover:translate-x-[100%]">
                                    </div> */}

                                    {/* Overlay Text */}
                                    {/* <div className="absolute inset-0 flex justify-center items-center text-pureWhite text-xl font-bold pointer-events-none truncate ">
                                        {brand?.name}
                                    </div> */}
                                    <Image
                                        alt='Slider Image'
                                        src={brand?.images[0]}
                                        height={200}
                                        width={200}
                                        className='h-full w-full shadow-lg  bg-blue-gray-200 object-fit'
                                    />
                                </div>
                            <span className='text-center pt-5 font-bold'>
                               {brand?.name} 
                            </span>
                            </div>
                        </Link>
                    </SwiperSlide>

                ))
            }

        </Swiper>
    )
}

export default Slider














// <SwiperSlide key={index}>
// <div className="flex justify-center items-center h-full">
//   {/* Circle Container */}
//   <div className="relative w-40 h-40 rounded-full bg-gray-200 overflow-hidden group cursor-pointer">
//     {/* Left Panel - slides out to the left on hover */}
//     <div className="absolute h-full w-1/2 bg-green-500 left-0 top-0 transition-all duration-700 group-hover:-translate-x-full"></div>

//     {/* Right Panel - slides out to the right on hover */}
//     <div className="absolute h-full w-1/2 bg-green-500 right-0 top-0 transition-all duration-700 group-hover:translate-x-full"></div>

//     {/* Image - split into two parts on hover */}
//     <div className="absolute inset-0 flex justify-center items-center text-pureWhite text-xl font-bold pointer-events-none">
//       {/* Left side of the image */}
//       <div className="absolute w-1/2 h-full left-0 overflow-hidden transform group-hover:translate-x-[-100%] transition-all duration-700">
//         <Image
//           height={200}
//           width={200}
//           src={shop.image}
//           alt="Shop Image"
//           className="object-cover h-full w-full"
//         />
//       </div>

//       {/* Right side of the image */}
//       <div className="absolute w-1/2 h-full right-0 overflow-hidden transform group-hover:translate-x-[100%] transition-all duration-700">
//         <Image
//           height={200}
//           width={200}
//           src={shop.image}
//           alt="Shop Image"
//           className="object-cover h-full w-full"
//         />
//       </div>
//     </div>
//   </div>
// </div>
// </SwiperSlide>